export default {
  "content": "<path d=\"M22.1-.02a22.11 22.11 0 100 44.22 22.11 22.11 0 000-44.22zm-1.84 11.08a1.852 1.852 0 011.845-1.985 1.85 1.85 0 011.845 1.986v12.92a1.85 1.85 0 01-3.69 0V11.06zm1.83 22.56a2.07 2.07 0 01-2.06-2.07 2.08 2.08 0 014.15 0 2.08 2.08 0 01-2.09 2.07z\" fill=\"#FF8F33\"/>",
  "attrs": {
    "width": "45",
    "height": "45",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};